module.exports = __webpack_public_path__ + "img/ynk.83d6407e.png";